import React, { useEffect, useState, useCallback } from "react";
import { getBranch, deleteBranch } from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { EditBranchs } from "./Form";
import { Deletemodel } from "../../Common/Functions";
import { NaviGate } from "../../../Utility/function";

const Branch = () => {
  const [branch, setBranchs] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [isAddMode, setIsAddMode] = useState(true); // Add or Edit flag
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [deleteID, setDeleteID] = useState("");
  const [deletemodel, showDeletemodel] = useState(false);
  const brandsPerPage = 10;

  // Fetch branch from API
  const fetchBranchs = useCallback(async (page = 1, text = "") => {
    try {
      const response = await getBranch(page, text);
      if (response.data?.data) {
        setBranchs(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    fetchBranchs();
  }, []);


  const handledeletemodel = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  }

  const openAddModal = () => {
    setIsAddMode(true);
    setSelectedBranch(null); // Reset selected branch when adding a new one
    setShowEditModal(true);
  };

  const openEditModal = (branch) => {
    setSelectedBranch(branch);
    setIsAddMode(false); // Set to edit mode
    setShowEditModal(true);
  };

  const handleDelete = async () => {
    try {
      await deleteBranch(deleteID);
      toast.success("Branch deleted successfully");
      fetchBranchs(); // Re-fetch branch after deletion
      showDeletemodel(false)
    } catch (error) {
      console.error("Error deleting branch:", error);
      toast.error("Error deleting branch");
    }
  };

  // Pagination logic
  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchBranchs(pageNumber);
  };

  const handleSearch = async (text) => {
    fetchBranchs(1, text)
  }

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Branch List</h6>
          <button
            type="button"
            onClick={openAddModal}
            className="btn btn-primary mb-0 text-normal rounded-1"
          >
            Add Branch
          </button>
        </div>

        <hr className="mt-1" />
        <div className="card h-100">
          <div className="card-body">
            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
              <div className="d-flex position-relative" style={{ width: "100%" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <img
                  src="/assets/images/icons/search.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "18px",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table
                id="example"
                className="table table-striped  table-sm table-bordered"
                style={{ width: "100%", fontFamily: "poppins" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Branch Name</th>
                    <th>Country</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {branch.length > 0 ? (
                    branch.map((branch, index) => {
                      const {
                        id,
                        country,
                        title
                      } = branch;
                      return (
                        <tr key={id}>
                          <td>
                            {(currentPage - 1) * brandsPerPage + index + 1}
                          </td>
                          <td>{title}</td>
                          <td>{country}</td>

                          <td>
                            <img src='/assets/images/icons/edit.png' onClick={() => openEditModal(branch)} height={"16px"} />
                            &nbsp;&nbsp;&nbsp;
                            <img src='/assets/images/icons/delete.png' className="mx-1" onClick={() => handledeletemodel(branch.id)} height={"16px"} />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No branch found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination controls */}
              <div className="pagination mb-1">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  className={`page-link text-normal rounded-1 ${currentPage === 1 ? "disabled" : ""
                    }`}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>

                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => handlePageChange(index + 1)}
                    className={`page-link text-normal rounded-1 ${currentPage === index + 1 ? "active" : ""
                      }`}
                  >
                    {index + 1}
                  </button>
                ))}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  className={`page-link text-normal rounded-1 ${currentPage === totalPages ? "disabled" : ""
                    }`}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
      {deletemodel && (
        <Deletemodel
          setShowModal={showDeletemodel}
          handleDelete={handleDelete}
        />
      )}

      {/* Modal for editing or adding branch */}
      <EditBranchs
        showModal={showEditModal}
        setShowModal={setShowEditModal} x
        fetchBranchs={fetchBranchs}
        selectedBranch={selectedBranch}
        isAddMode={isAddMode}
      />
    </div>
  );
};

export default Branch;
